
var cardGroupLess = {};
import genaration from '../../utils/classname';
export var cardGroupClass = genaration(cardGroupLess, 'card-group');